import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'lib-sessions-preview',
    templateUrl: './sessions-preview.component.html',
    styleUrls: ['./sessions-preview.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SessionsPreviewComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
